import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import store from './store';
import routes from './router';
import PrivateRoute from './components/auth/PrivateRoute';
import App from './components/App';
import Login from './components/home/Login';
import './style/antd.min.css';

//TODO:https-saml
//import Home from './components/home/Home';
//import './style/antd.min.css';
import './style/main.less';
import moment from 'moment';
import 'moment/locale/zh-cn';
import Highcharts from 'react-highcharts';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsDrilldown from 'highcharts/modules/drilldown';


HighchartsExporting(Highcharts.Highcharts);
HighchartsDrilldown(Highcharts.Highcharts);
moment.locale('zh-cn');

ReactDOM.render(
    <Provider store={store}>
        <HashRouter>
            <div className="router-index">
                <Switch>
                    <Route path="/" component={() => <Redirect to="/home"/>} exact={true} />
                    <Route path="/login" component={Login} isLogin={true} />
                    <App>
                        {
                            routes.map((route, index) => (
                                <PrivateRoute
                                    key={index}
                                    path={route.path}
                                    exact={route.exact}
                                    component={route.render}
                                />))
                        }
                    </App>
                </Switch>
            </div>
        </HashRouter>
    </Provider>,
    document.getElementById('contentApp'),
);



// WEBPACK FOOTER //
// ./src/index.js